/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportacaoFontesSeladasAutorizacaoFormDto } from '../models/exportacao-fontes-seladas-autorizacao-form-dto';
import { ExportacaoFontesSeladasConsentimentoFormDto } from '../models/exportacao-fontes-seladas-consentimento-form-dto';
import { ExportacaoFontesSeladasCriteriaDto } from '../models/exportacao-fontes-seladas-criteria-dto';
import { ExportacaoFontesSeladasDto } from '../models/exportacao-fontes-seladas-dto';
import { ExportacaoFontesSeladasFormDto } from '../models/exportacao-fontes-seladas-form-dto';
import { ExportacaoFontesSeladasPageDto } from '../models/exportacao-fontes-seladas-page-dto';


/**
 * Transferência/Exportação de Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class ExportacaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getExportacoesFs
   */
  static readonly GetExportacoesFsPath = '/exportacao-fontes-seladas';

  /**
   * Pesquisar exportações.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportacoesFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacoesFs$Response(params?: {
    criteria?: ExportacaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.GetExportacoesFsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar exportações.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportacoesFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacoesFs(params?: {
    criteria?: ExportacaoFontesSeladasCriteriaDto;
  }): Observable<ExportacaoFontesSeladasPageDto> {

    return this.getExportacoesFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasPageDto>) => r.body as ExportacaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation createExportacaoFs
   */
  static readonly CreateExportacaoFsPath = '/exportacao-fontes-seladas';

  /**
   * Submeter pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createExportacaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createExportacaoFs$Response(params?: {
    body?: {
'formDto'?: ExportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.CreateExportacaoFsPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Submeter pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createExportacaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createExportacaoFs(params?: {
    body?: {
'formDto'?: ExportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<ExportacaoFontesSeladasDto> {

    return this.createExportacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasDto>) => r.body as ExportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation getExportacaoFs
   */
  static readonly GetExportacaoFsPath = '/exportacao-fontes-seladas/{id}';

  /**
   * Obter exportação de Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportacaoFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacaoFs$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.GetExportacaoFsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Obter exportação de Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportacaoFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacaoFs(params: {
    id: number;
  }): Observable<ExportacaoFontesSeladasDto> {

    return this.getExportacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasDto>) => r.body as ExportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateExportacaoFs
   */
  static readonly UpdateExportacaoFsPath = '/exportacao-fontes-seladas/{id}';

  /**
   * Editar Pedido de Enquadramento Exportação Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportacaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateExportacaoFs$Response(params: {
    id: number;
    body?: {
'formDto'?: ExportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.UpdateExportacaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Editar Pedido de Enquadramento Exportação Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateExportacaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateExportacaoFs(params: {
    id: number;
    body?: {
'formDto'?: ExportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<ExportacaoFontesSeladasDto> {

    return this.updateExportacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasDto>) => r.body as ExportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoExportacaoFs
   */
  static readonly UpdateAutorizacaoExportacaoFsPath = '/exportacao-fontes-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoExportacaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExportacaoFs$Response(params: {
    id: number;
    body?: ExportacaoFontesSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.UpdateAutorizacaoExportacaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoExportacaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExportacaoFs(params: {
    id: number;
    body?: ExportacaoFontesSeladasAutorizacaoFormDto
  }): Observable<ExportacaoFontesSeladasDto> {

    return this.updateAutorizacaoExportacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasDto>) => r.body as ExportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation docConsentimento
   */
  static readonly DocConsentimentoPath = '/exportacao-fontes-seladas/{id}/consentimento';

  /**
   * Documento de pedido de consentimento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `docConsentimento()` instead.
   *
   * This method doesn't expect any request body.
   */
  docConsentimento$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.DocConsentimentoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/msword'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Documento de pedido de consentimento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `docConsentimento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  docConsentimento(params: {
    id: number;
  }): Observable<Blob> {

    return this.docConsentimento$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation updateConsentimentoExportacaoFs
   */
  static readonly UpdateConsentimentoExportacaoFsPath = '/exportacao-fontes-seladas/{id}/consentimento';

  /**
   * Preencher consentimento de um pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConsentimentoExportacaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConsentimentoExportacaoFs$Response(params: {
    id: number;
    body?: ExportacaoFontesSeladasConsentimentoFormDto
  }): Observable<StrictHttpResponse<ExportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.UpdateConsentimentoExportacaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Preencher consentimento de um pedido de exportação de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateConsentimentoExportacaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConsentimentoExportacaoFs(params: {
    id: number;
    body?: ExportacaoFontesSeladasConsentimentoFormDto
  }): Observable<ExportacaoFontesSeladasDto> {

    return this.updateConsentimentoExportacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesSeladasDto>) => r.body as ExportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoExportacao
   */
  static readonly PreviewDocAutorizacaoExportacaoPath = '/exportacao-fontes-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoExportacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesSeladasService.PreviewDocAutorizacaoExportacaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoExportacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacao(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoExportacao$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
